import { ApiError } from '../lib/api.js';
import { t } from '../lib/i18n.js';

/**
 * A failed request must never leave an empty screen: the reason is always
 * visible, with a way to retry.
 */
export function ErrorNotice({
  error,
  onRetry,
}: {
  error: unknown;
  onRetry: () => void;
}): JSX.Element {
  const isAuth = error instanceof ApiError && error.status === 401;
  const serverMessage = error instanceof ApiError ? error.payload.message : null;
  const message = isAuth
    ? `Вход отклонён: ${serverMessage ?? 'причина неизвестна'}.`
    : (serverMessage ?? 'Не получилось связаться с сервером. Проверь соединение.');

  return (
    <div className="paper-card space-y-3 p-4">
      <p className="text-sm text-ink">{message}</p>
      {error instanceof ApiError ? (
        <p className="text-xs text-ink-soft">
          {error.payload.code} · {error.status}
        </p>
      ) : null}
      <button
        type="button"
        onClick={onRetry}
        className="rounded-[var(--radius-card)] bg-[var(--ink)] px-4 py-2 text-sm text-[var(--paper)]"
      >
        Повторить
      </button>
    </div>
  );
}

export function LoadingNotice(): JSX.Element {
  return <p className="py-8 text-center text-sm text-ink-soft">{t('common.loading')}</p>;
}
